import { Card, Typography, Button, Container, Stack, TableContainer, TableHead, TableRow, TableCell, Checkbox, Table, TableBody, Popover, MenuItem, IconButton, Avatar, Dialog, DialogTitle, DialogContent, Grid, TextField, Autocomplete, FormControl, Select, Chip, CardMedia, CardContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Iconify from "src/components/iconify";
import '../../Common_css/style.css';
import fb from '../../components/icons/fb.png';
import insta from '../../components/icons/instagram.png';
import website from '../../components/icons/website.png';
import twitter from '../../components/icons/twitter.png';
import { getData } from "src/webService/webService";
import { toast } from "react-toastify";
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import { useNavigate, useParams } from "react-router-dom";
import productThumbnail from '../../components/icons/brand.png';



export default function ViewProduct({ id, sellerResponse, handleViewProduct }) {

    console.log(id, 'iddddddddddd');
    console.log(sellerResponse, 'sellerResponseeeeeeeee');

    const Token = sessionStorage.getItem('Token');
    const [productList, setProductList] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [seletectedProduct, setSeletectedProduct] = useState();
    const [isOpenGallery, setIsOpenGallery] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [galleryImages, setGalleryImages] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const { sellerid, brandid } = useParams();
    const [viewProduct, setViewProduct] = useState(false);
    const [getAnalysisData, setGetAnalysisData] = useState({});
    const navigate = useNavigate();


    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
    }

    const dashboardAnalytics = async (page, brand_id) => {
        const params = {
            page: page,
            per_page: limit,
        }
        try {
            const res1 = await getData(`sellers/brands/${brandid}/analytics`, null, Token);
            setGetAnalysisData(res1);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }


    const getProductById = async (page) => {
        debugger
        const params = {
            page: page,
            per_page: limit,
        }
        try {
            const res = await getData(`sellers/${sellerid}/brands/${brandid}/products`, params, Token);
            console.log(res, "res.name");
            setProductList(res?.data);
            setTotalItems(res?.total);
            setTotalPages(res?.last_page);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }


    useEffect(() => {
        getProductById(currentPage);
        dashboardAnalytics();
    }, [limit])

    const openGallery = (index) => {
        setPhotoIndex(index);
        setIsOpenGallery(true);
    };

    const handleProduct = (index) => {
        const selectedItem = productList[index];
        console.log(selectedItem, 'selectedItem');
        setSeletectedProduct(selectedItem);
        setGalleryImages(selectedItem?.galleryFiles);
    };

    const bactToViewProduct = () => {
        navigate('/admin/seller')
        // setViewProduct(true);

    }


    return (
        <>

            <Helmet>
                <title> View Product</title>
            </Helmet>

            <Container className='p-0'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" className='title-color' gutterBottom>
                        <Iconify className='backIcon pointer' sx={{ marginRight: '10px' }} onClick={bactToViewProduct} icon="eva:arrow-back-fill" />
                        View Product
                    </Typography>
                </Stack>

                <Container maxWidth="xl" className="mt-3">
                    <Grid container spacing={3}>

                        <Grid item xs={12} md={6} lg={3}>
                            <div className='dashboardCard'>
                                <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:cube-outline" />Total Products</p>
                                <h4>{getAnalysisData?.products ? getAnalysisData?.products : 0}</h4>
                                <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_products ? getAnalysisData?.recent_products : 0}</b> Product in last 7 days</p>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                            <div className='dashboardCard'>
                                <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Calls</p>
                                <h4>{getAnalysisData?.calls ? getAnalysisData?.calls : 0}</h4>
                                <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_calls ? getAnalysisData?.recent_calls : 0}</b> Calls in last 7 days</p>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                            <div className='dashboardCard'>
                                <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:message-square-outline" />Total Chat</p>
                                <h4>{getAnalysisData?.chats ? getAnalysisData?.chats : 0}</h4>
                                <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_chats ? getAnalysisData?.recent_chats : 0}</b> Chats in last 7 days</p>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                            <div className='dashboardCard'>
                                <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Callback Request</p>
                                <h4>{getAnalysisData?.callback_requests ? getAnalysisData?.callback_requests : 0}</h4>
                                <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_callback_requests ? getAnalysisData?.recent_callback_requests : 0}</b> Callback in last 7 days</p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
                {productList?.length === 0 ? (
                    <Card className='card-bg mt-5' style={{ height: "500px", overflowY: "scroll", width: "100%", background: '#dfecf1', padding: '30px' }}>
                        <div className="col-12 text-center mt-5">
                            <div className="d-flex justify-content-center align-items-center">
                                <img width='30%' src={productThumbnail} />
                            </div>
                            <p>No products available</p>
                        </div>
                    </Card>

                ) : (
                    <Card className='card-bg' style={{ height: "500px", overflowY: "scroll", width: "100%", background: '#dfecf1', padding: '30px' }}>
                        <div className="row">
                            <Grid container spacing={2} marginTop={0}>
                                {productList?.map((item, index) => (
                                    <div className="col-lg-4" key={index}>
                                        <div className='cardLayout mx-2'>
                                            <div className='p-3'>
                                                <img src={item?.thumbnail} />
                                            </div>
                                            <h3 className='px-3 pt-2 pb-1 text-center'>{item?.name}</h3>
                                            {/* <p className='text-center fs-14'>{item?.description}</p> */}
                                            <div className='d-flex justify-content-center'>
                                                <Button variant="contained" className='Button' onClick={(e) => { handleProduct(index); handleOpenModal() }}>
                                                    View Product Detail
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Grid>
                        </div>
                        <div className="d-flex flex-wrap justify-content-end m-3">
                            <FormControl variant="outlined" size="small" style={{ width: "7%" }}>
                                <Select
                                    labelId="limit-label"
                                    id="limit-select"
                                    value={limit}
                                    onChange={handleLimitChange}
                                >
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                    <MenuItem value={TotalItems}>All</MenuItem>
                                </Select>
                            </FormControl>
                            <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                <Iconify icon={"grommet-icons:previous"} />
                            </Button>
                            <Button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                            >
                                <Iconify icon={"grommet-icons:next"} />
                            </Button>
                        </div>
                    </Card>
                )}

            </Container>
            <Dialog open={openModal} onClose={handleClose} maxWidth="lg" fullWidth>
                <div className="d-flex justify-content-between">
                    <DialogTitle>Product Detail</DialogTitle>
                    <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px', cursor: 'pointer' }} onClick={handleClose} />
                </div>
                <DialogContent>
                    <div className="row">
                        <div className="col-lg-5">
                            <img
                                src={seletectedProduct?.thumbnail}
                                alt="thumbnail"
                                style={{
                                    height: "400px",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                    borderRadius: "10px",
                                }}
                            />
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <h3>{seletectedProduct?.name}</h3>
                                <p>{seletectedProduct?.description}</p>
                            </div>
                            <div className="mt-4">
                                <p><strong>Fabric Type:</strong> {seletectedProduct?.fabric_type ? seletectedProduct?.fabric_type : 'Not Available'}</p>
                                <p><strong>Colors:</strong> {seletectedProduct?.colors ? seletectedProduct?.colors : 'Not Available'}</p>
                                <p><strong>Size:</strong> {seletectedProduct?.sizes ? seletectedProduct?.sizes : 'Not Available'}</p>
                            </div>

                            <div className="d-flex align-items-center">
                                {galleryImages?.map((image, index) => (
                                    <div key={index} style={{ position: "relative", margin: "10px" }}>

                                        {/* Image */}
                                        <Avatar
                                            src={image}
                                            sx={{
                                                height: "90px",
                                                width: "60px",
                                                borderRadius: "10%",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => openGallery(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </DialogContent>
            </Dialog>
            {/* Lightbox for Image Preview */}
            {isOpenGallery && galleryImages.length > 0 && (
                <Lightbox
                    mainSrc={`${galleryImages[photoIndex]}`}
                    nextSrc={`${galleryImages[(photoIndex + 1) % galleryImages.length]}`}
                    prevSrc={`${galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length]}`}
                    onCloseRequest={() => setIsOpenGallery(false)}
                    onMovePrevRequest={() => setPhotoIndex((photoIndex + galleryImages.length - 1) % galleryImages.length)}
                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % galleryImages.length)}
                />
            )}
        </>
    )
}